import { useEffect, useState } from 'react';

import { getClassName } from '../input-class';
import { TextInputProps } from './text-input.component';

interface ViewProps {
    valid: boolean;
    touched: boolean;
    inputClass: string;
    changeTouched: React.Dispatch<React.SetStateAction<boolean>>;
    isValid: () => boolean;
}

const useTextInput = (props: TextInputProps): ViewProps => {
    const [touched, changeTouched] = useState<boolean>(false);
    const [valid, changeValid] = useState<boolean>(false);

    const isValid = (): boolean => {
        let check = true;
        if (check === true && props.required === true && (props.value === '' || props.value === undefined)) check = false;
        if (props.valid !== undefined && check === true) check = props.valid;
        changeValid(check);
        return check;
    };

    useEffect(() => {
        if (props.isValidCallback) {
            props.isValidCallback(isValid());
        } else isValid();
    }, [props.value, props.valid]);

    useEffect(() => {
        if (props.submitted) {
            !touched && changeTouched(true);
        }
    }, [props.submitted]);
    return {
        valid,
        touched,
        inputClass: props.useConditionedStyling === false ? 'form-control' : getClassName(touched, valid, props.value),
        isValid,
        changeTouched
    };
};

export default useTextInput;
